var map = {
	"./bg.jpg": "d1b4",
	"./logo.png": "4ffd",
	"./logo/Octocat.png": "170a",
	"./logo/django.png": "b850",
	"./logo/drf.png": "4623",
	"./logo/js.png": "4d42",
	"./logo/js.png:Zone.Identifier": "ad16",
	"./logo/linux.png": "644b",
	"./logo/nginx.png": "d614",
	"./logo/postgres.png": "279c",
	"./logo/python.png": "90f2",
	"./logo/vuejs.png": "7b0b0",
	"./photo.jpg": "1e22",
	"./projects/pms.png": "ad00",
	"./projects/rms.png": "8fb2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";